import { performGetRequest } from '@atlassian/jira-fetch';
import type { ProjectSearchResponse } from './types';

// TODO WOLVES-576 cleanup after migration
export const fetchProjectAvatar = async (projectId: string) => {
	const foundProjects = await performGetRequest<ProjectSearchResponse>(
		`/rest/api/3/project/search?${new URLSearchParams({ id: projectId }).toString()}`,
	);

	return foundProjects?.values?.[0]?.avatarUrls?.['48x48'] || '';
};
